/**
 * Роли с правами администратора платформы: публикация своего без модерации,
 * админские подсказки в mini-app, доступ к разделам админки кроме CRM.
 * CRM для менеджера города — `hasCrmTeamRole` (CITY_MODERATOR + legacy CRM_MANAGER).
 */
export const PLATFORM_ADMIN_ROLES = ['SUPERADMIN', 'CITY_MODERATOR'] as const;

export function hasPlatformAdminRole(roles: readonly string[] | null | undefined): boolean {
  return (roles ?? []).some((role) => (PLATFORM_ADMIN_ROLES as readonly string[]).includes(role));
}

/**
 * Доступ к CRM в админке: SUPERADMIN, менеджер города (`CITY_MODERATOR`) или
 * legacy `CRM_MANAGER` в БД. В UI выдаётся только модератор города + города.
 */
export function hasCrmTeamRole(roles: readonly string[] | null | undefined): boolean {
  const list = roles ?? [];
  return list.includes('SUPERADMIN') || list.includes('CITY_MODERATOR') || list.includes('CRM_MANAGER');
}
